import { aggregate } from '@/providers/backendClient';
import {
  createCountPipeline,
  createFilteringStage,
  createPagingStages,
  createSortStage,
  CustomPipelineFactory,
} from '@/providers/dataProvider';

export const deadLetterQueueCustomFetcher: CustomPipelineFactory =
  async ({
    sort,
    filter: { collectionName, userId, documentId, ...filter },
    page,
    perPage,
    signal,
  }) => {
    // Handle any special filter transformations
    const collectionNameMatch = collectionName
      ? { 'crudOperation.type': { $in: collectionName } }
      : {};

    const userIdMatch = userId ? { 'userMetadata.id': userId } : {};

    const documentIdMatch = documentId
      ? { 'crudOperation.id': documentId }
      : {};

    const combinedFilter = {
      ...filter,
      ...collectionNameMatch,
      ...userIdMatch,
      ...documentIdMatch,
    };

    const match = createFilteringStage(combinedFilter);
    const sortStage = createSortStage(sort);
    const pagingPipeline = createPagingStages(page, perPage);

    const resultsPipeline = [match, sortStage, ...pagingPipeline];

    const countPipeline = createCountPipeline([match]);

    const pipelines = {
      results: resultsPipeline,
      total: countPipeline,
    };

    const { results, total: [{ count = 0 } = {}] = [] } =
      await aggregate('dead-letter-queue', pipelines, {
        allowDiskUse: true,
        ...(signal ? { signal } : {}),
      });

    return { results, total: count };
  };
